// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 796 ? "rec-cache-next" : chunkId) + "." + {"796":"8c5bc73b","873":"c2b8d480","977":"30634b81"}[chunkId] + ".js";
};